import { useMutation } from "react-query";
import http from "infra/http";

function useExcluirTransferencia() {
  return useMutation(
    '/v1/transferencia',
    async (id: string) => {
      const {data} = await http.delete(`/v1/transferencia/${id}`);
      return data as {id: string};
    },
    { retry: false }
  );
}

export default useExcluirTransferencia;
